import { render } from "./PreRegistrationSheetView.vue?vue&type=template&id=6952b0a6&scoped=true"
import script from "./PreRegistrationSheetView.vue?vue&type=script&lang=js"
export * from "./PreRegistrationSheetView.vue?vue&type=script&lang=js"

import "./PreRegistrationSheetView.vue?vue&type=style&index=0&id=6952b0a6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6952b0a6"]])

export default __exports__